import { topicItems } from "@/mocks/home";

export default function HotTopics() {
  const featured = topicItems.find((t) => t.featured)!;
  const rest = topicItems.filter((t) => !t.featured);

  return (
    <section id="hot" className="scroll-mt-20">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="mb-10 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
              <i className="ri-fire-fill text-base"></i>
              今日热瓜
            </span>
            <h2 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              大家都在围观什么
            </h2>
          </div>
          <a
            href="#discuss"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-foreground-950"
          >
            到讨论区聊聊
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* 大小卡混排网格 */}
        <div className="grid gap-5 lg:grid-cols-3">
          {/* 大卡 */}
          <a
            href="#discuss"
            className="group relative overflow-hidden rounded-xl lg:col-span-2 lg:row-span-2"
          >
            <div className="relative h-64 w-full overflow-hidden md:h-80 lg:h-full lg:min-h-[420px]">
              <img
                src={featured.image}
                alt={featured.title}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent"></div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
              <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-flashlight-fill text-xs"></i>
                {featured.tag}
              </span>
              <h3 className="mt-3 max-w-2xl font-heading text-2xl font-bold leading-snug text-white md:text-3xl">
                {featured.title}
              </h3>
              <p className="mt-2 hidden max-w-2xl text-sm leading-relaxed text-background-100 md:block">
                {featured.summary}
              </p>
              <div className="mt-4 flex items-center gap-4 text-xs text-background-100">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {featured.views}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-message-3-line"></i>
                  {featured.replies} 讨论
                </span>
                <span className="inline-flex items-center gap-1 rounded-full bg-white/15 px-2 py-0.5">
                  热度 {featured.heat}
                </span>
              </div>
            </div>
          </a>

          {/* 小卡 */}
          {rest.map((t) => (
            <a
              key={t.id}
              href="#discuss"
              className="group flex overflow-hidden rounded-xl border border-background-200/70 bg-background-100/50"
            >
              <div className="relative h-auto w-28 shrink-0 overflow-hidden sm:w-36">
                <img
                  src={t.image}
                  alt={t.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex min-w-0 flex-col justify-center gap-1.5 p-4">
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                  <i className="ri-price-tag-3-line"></i>
                  {t.tag}
                </span>
                <h3 className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {t.title}
                </h3>
                <p className="line-clamp-2 text-xs leading-relaxed text-foreground-500">
                  {t.summary}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span>{t.views}</span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-chat-1-line"></i>
                    {t.replies}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}